import { TableColumnHeader } from '@/components/data-table/table-column-header'
import { ColumnDef } from '@tanstack/react-table'
import { BillingHistoryTableAction } from './billing-history-table-action'
import { IBillingHistoryItem } from '../_data/billing-history-DTO'
import { cn } from '@/lib/utils'
export const BillingHistoryTableColumns: ColumnDef<IBillingHistoryItem>[] = [
  {
    accessorKey: 'count',
    enableSorting: false,
    header: ({ column }) => <TableColumnHeader column={column} title={'#'} />,
    cell: ({ row }) => <div>{row.getValue('count')}</div>,
  },
  {
    accessorKey: 'created',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Date'} />
    ),
    cell: ({ row }) => <div>{row.getValue('created')}</div>,
  },
  {
    accessorKey: 'number',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Invoice Number'} />
    ),
    cell: ({ row }) => <div>{row.getValue('number')}</div>,
  },
  {
    accessorKey: 'amount',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Total'} />
    ),
    cell: ({ row }) => <div>{row.getValue('amount')}</div>,
  },
  {
    accessorKey: 'status',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Status'} />
    ),
    cell: ({ row }) => (
      <div>
        <span
          className={cn(
            'font-bold text-xs bg-gray-100 text-gray-700 rounded-md px-2 py-1',
            {
              ' bg-green-100 text-green-700':
                row.getValue('status') === 'Paid',
            }
          )}
        >
          {row.getValue('status')}
        </span>
      </div>
    ),
  },
  {
    accessorKey: 'action',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader
        column={column}
        title={'Action'}
        className="item-center flex justify-center"
      />
    ),
    cell: ({ row }) => <BillingHistoryTableAction row={row} />,
  },
]
